import { useTranslation } from "react-i18next";
import Footer from "../Component/Dynamic/Footer";
import CameraCaptureButton from "../Component/Dynamic/CameraCaptureButton";
import BackToTopButton from "../Component/Dynamic/BackToTopBtn";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ChatApp from "../Component/Dynamic/ChatApp";
import { BasicColor, GreenContrast, OliveGreen } from "../Utils/constants";
import { simpleBase62Decode } from "../Funcs/Encryption";

function ChatAppScr() {
  const { t, i18n } = useTranslation();
  const [isPageValid, setIsPageValid] = useState(false);
  const { search } = useLocation();
  const location = useLocation();
  const params = new URLSearchParams(search);
  const timeLimit = simpleBase62Decode(params.get("tl"));
  const timeOfCreation = simpleBase62Decode(params.get("tn"));
  const id = simpleBase62Decode(params.get("mrn"));

  useEffect(() => {
    if (location.pathname === "/chat") {
      const currentTime = Date.now();
      if (Number(timeLimit) + Number(timeOfCreation) >= currentTime) {
        setIsPageValid(true);
      }
    }
  }, []);

  return (
    <div style={{ backgroundColor: GreenContrast }}>
      {isPageValid ? (
        <div>
          <ChatApp />
        </div>
      ) : (
        <h1>Expired page</h1>
      )}
    </div>
  );
}

export default ChatAppScr;
